<template>
    <form @submit.prevent="validarFormulario()"
          data-vv-scope="tarea"
    >
        <!-- SECCIÓN DE GENERALES -->
        <b-card class="contenedor">
            <div slot="header"
                 class="text-center font-weight-bold"
            >
                GENERALES
                <b-button class="float-right ml-1"
                          size="sm"
                          variant="secondary"
                          to="/analisis-de-riesgos/analisis"
                >
                    <i class="fa fa-reply fa-lg"/> Volver
                </b-button>
            </div>
            <div class="row">
                <div class="form-group col-md-6"
                     v-if="accion === 'Actualizar'"
                >
                    <label for="fecha"> Fecha <span class="text-danger"
                                                    v-text="'(*)'"
                    /> : </label>
                    <br/>
                    <el-date-picker
                        v-model="tarea.fecha"
                        id="fecha"
                        name="fecha"
                        class="text-uppercase"
                        filterable
                        :clearable="false"
                        :editable="false"
                        type="date"
                        value-format="yyyy-MM-dd"
                        data-vv-as=" "
                        v-validate="{rules: { required: !!tarea.id_empresa, date_format: 'yyyy-MM-dd' }}"
                        @change="getWorkers"
                    >
                    </el-date-picker>
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.fecha')"
                    />
                </div>

                <!-- Empresa -->
                <div class="form-group col-md-6"
                     v-if="mostrar_select"
                >
                    <label for="id_empresa">
                        Empresa <span class="text-danger"
                                      v-text="'(*)'"
                    /> :
                    </label>
                    <el-select
                        id="id_empresa"
                        name="id_empresa"
                        class="text-uppercase"
                        filterable
                        clearable
                        :disabled="accion === 'Actualizar'"
                        v-model="tarea.id_empresa"
                        placeholder="Seleccione una opción"
                        size="small"
                        data-vv-as=" "
                        v-validate="'required'"
                        @change="obtenerDatosPorEmpresa"
                        remote
                        :remote-method="obtenerEmpresas"
                    >
                        <el-option
                            v-for="empresa in empresas"
                            :key="empresa.id"
                            :label="empresa.nombre"
                            :value="empresa.id"
                        />
                    </el-select>
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.id_empresa')"
                    />
                </div>

                <!-- Ubicación -->
                <div class="form-group col-md-6">
                    <label for="location_ids">
                        Ubicaciones
                        <span class="text-danger" v-text="'(*)'"/> :
                    </label>
                    <tree-select
                        name="location_ids"
                        id="location_ids"
                        clearable
                        :options="ubicaciones"
                        placeholder="Seleccionar"
                        data-vv-as=" "
                        v-model="tarea.location_ids"
                        :defaultExpandLevel="Infinity"
                        :multiple="true"
                        :normalizer="normalizer"
                        :disable-branch-nodes="true"
                        no-results-text="No se encontraron resultados."
                        value-consists-of="ALL"
                        noOptionsText="No hay resultados para mostrar"
                        @input="establecerIdUbicacion"
                    >
                        <label slot="option-label" slot-scope="{ node, labelClassName }" :class="labelClassName">
                        {{ node.label }}
                        </label>
                    </tree-select>
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.location_ids')"
                    />
                </div>

                <!-- Fabricante -->
                <!-- <div class="form-group col-md-6">
                    <label for="id_fabricante"> Fabricante </label>
                    <el-select
                        id="id_fabricante"
                        name="id_fabricante"
                        class="text-uppercase"
                        v-model="tarea.id_fabricante"
                        popper-class="el-select-personalizado"
                        placeholder="Seleccione una opción"
                        :disabled="accion === 'Actualizar'"
                        size="small"
                        data-vv-as=" "
                        v-validate="''"
                        filterable
                        clearable
                        remote
                        :remote-method="obtenerFabricantes"
                        @change="establecerIdProducto(null)"
                        :loading="cargando_datos_select"
                    >
                        <el-option
                            v-for="item in fabricantes"
                            :key="item.id"
                            :label="item.nombre"
                            :value="item.id"
                        />
                    </el-select>
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.id_fabricante')"
                    />
                </div> -->

                <!-- Producto -->
                <div class="form-group col-md-6">
                            <label for="id_producto"
                                   class="w-100"
                            >
                                Producto
                                <span class="text-danger"
                                      v-text="'(*)'"
                                /> :
                            </label>
                            <el-select
                                id="id_producto"
                                name="id_producto"
                                class="text-uppercase"
                                v-model="tarea.id_producto"
                                placeholder="Seleccione una opción"
                                size="small"
                                data-vv-as=" "
                                v-validate="'required'"
                                :disabled="accion === 'Actualizar'"
                                filterable
                                @change="obtenerDatosPorProducto"
                                remote
                                :remote-method="obtenerProductos"
                            >
                                <el-option
                                    v-for="item in productos"
                                    :key="item.id"
                                    :label="item.nombre"
                                    :value="item.id"
                                >
                                    <div>
                                        <span class="font-weight-bold">{{
                                                item.fabricante ? item.fabricante.nombre + ' - ' : ''
                                            }}</span>
                                        {{ item.nombre }}
                                    </div>
                                </el-option>
                            </el-select>
                            <div
                                class="text-danger span-error small"
                                v-text="errors.first('tarea.id_producto')"
                            />
                            <strong v-if="tarea.id_producto"
                                v-text="fabricante ? 'Fabricante: ' + fabricante : 'NO REGISTRA'"
                            ></strong>
                </div>

                <!-- Categorías -->
                <div class="form-group col-md-6">
                    <label for="id_categoria">
                        Frase <span class="text-danger"
                                    v-text="'(*)'"
                    /> :
                    </label>
                    <el-select
                        id="id_categoria"
                        name="id_categoria"
                        class="text-uppercase"
                        v-model="tarea.id_categoria"
                        placeholder="Seleccione una opción"
                        size="small"
                        data-vv-as=" "
                        v-validate="'required'"
                        :disabled="!tarea.id_producto"
                        filterable
                    >
                        <el-option-group
                            v-for="grupo in categorias_sga"
                            :key="grupo.id"
                            :label="grupo.grupo"
                        >
                            <el-option
                                v-for="categoria in grupo.opciones"
                                :key="categoria.id"
                                :label="categoria.codigo + ' ' + categoria.categoria"
                                :value="categoria.id"
                            >
                                <span
                                    :class="!!categoria.producto ? 'text-success font-weight-bold' : ''"
                                >
                                    {{ categoria.codigo + ' ' + categoria.categoria }}
                                </span>
                            </el-option>
                        </el-option-group>
                    </el-select>
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.id_categoria')"
                    />
                </div>

                <div v-if="estado !== ''" class="form-group col-md-3 ml-2">
                    <label>
                        Estado del producto:
                    </label>
                    <el-select v-if="mostrar_select"
                        class="text-uppercase"
                        placeholder="Seleccione un estado"
                        v-model="tarea.estado_producto"
                        size="small"
                    >
                      <el-option
                        v-for="item in estados"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      >
                        {{ item.text }}
                       </el-option>
                     </el-select>
                </div>

                <div class="form-group col-md-2">
                            <label>&nbsp;</label>
                            <div class="d-flex">
                                <b-button-group>
                                    <el-tooltip
                                        effect="dark"
                                        placement="top"
                                        content="Ver propiedades"
                                        popper-class="py-1 px-2"
                                    >
                                        <b-button
                                            variant="danger"
                                            class="float-right px-4"
                                            size="sm"
                                            @click="_obtenerPropiedades()"
                                            :disabled="!tarea.id_producto"
                                        >
                                            <i class="fa fa-eye"/>
                                        </b-button>
                                    </el-tooltip>
                                    <el-tooltip
                                        effect="dark"
                                        placement="top"
                                        content="Ver ficha de seguridad"
                                        popper-class="py-1 px-2"
                                    >
                                        <b-button
                                            variant="warning"
                                            class="float-right px-4"
                                            size="sm"
                                            @click="obtainSafetyDataSheets(tarea.id_producto)"
                                            :disabled="!tarea.id_producto"
                                        >
                                            <i class="fa fa-file-text-o"
                                               aria-hidden="true"
                                            ></i>
                                        </b-button>
                                    </el-tooltip>
                                    <el-tooltip v-if="mostrar_select"
                                        effect="dark"
                                        placement="top"
                                        content="Nuevo producto"
                                        popper-class="py-1 px-2"
                                    >
                                        <b-button
                                            variant="primary"
                                            class="float-right px-4"
                                            size="sm"
                                            @click="_setModalCreateNewProductView()"
                                            :disabled="!tarea.id_empresa"
                                            v-if="accion !== 'Actualizar'"
                                        >
                                            <i class="fa fa-plus"/>
                                        </b-button>
                                    </el-tooltip>
                                </b-button-group>
                            </div>
                        </div>
            </div>
        </b-card>

        <!-- SECCIÓN COMPONENTES -->
        <b-card class="contenedor">
            <div>
                <b-row v-if="mostrar_select">
                    <b-col md="12"
                           lg="12"
                    >
                        <b-button variant="primary"
                                  class="pull-right"
                                  @click="modal_tlv = true"
                        >
                            Ver TLV
                        </b-button>
                    </b-col>
                </b-row>
                <b-modal v-model="modal_tlv"
                         size="xl"
                         hide-footer
                >
                    <cas-tlv
                        :ari="true"
                        @obtenerDatosPorProducto="obtenerDatosPorProducto(tarea.id_producto)"
                    />
                </b-modal>
            </div>
            <div slot="header"
                 class="text-center font-weight-bold"
            >COMPONENTES
            </div>
            <div class="row">
                <div class="col-12">
                    <b-table responsive
                             hover
                             :items="componentes"
                             :fields="columnas"
                             show-empty
                             small
                             striped
                    >
                        <template #empty="scope">
                            <div v-if="tarea.id_producto"
                                 class="text-center"
                            >
                                No hay componentes activos para mostrar.
                                <b-button
                                    v-if="mostrar_select"
                                    class="ml-2"
                                    size="sm"
                                    @click="establecerModalProductoComponente(true)"
                                    variant="primary"
                                >Agregar componente
                                </b-button
                                >

                                <modal-producto-componente
                                    :producto="tarea.id_producto"
                                    @obtenerDatosPorProducto="obtenerDatosPorProducto(tarea.id_producto)"
                                />
                            </div>
                            <div v-else
                                 class="text-center"
                            >
                                No hay componentes activos para mostrar
                            </div>
                        </template>

                        <template v-slot:cell(select)="data">
                            <el-checkbox
                                v-model="data.item.select"
                                clearable
                                @change="establecerIdComponente(data.item.prod_component_id)"
                            />
                        </template>
                    </b-table>
                </div>
            </div>
        </b-card>

        <!-- SECCIÓN DE DESCRIPCIÓN TAREA -->
        <b-card class="contenedor">
            <div slot="header"
                 class="text-center font-weight-bold"
            >DESCRIPCIÓN TAREA
            </div>
            <div class="row">
                <!-- Tarea -->
                <b-col md="4">
                    <b-form-group>
                        <label for="ari_task_id">
                            Tarea
                        </label>
                        <b-row>
                            <b-col>
                                <el-select v-model="tarea.ari_task_id"
                                           id="ari_task_id"
                                           name="ari_task_id"
                                           filterable
                                           size="small"
                                           placeholder="Seleccione una tarea"
                                           no-data-text="No hay datos que coincidan"
                                           no-match-text="No hay datos que coincidan"
                                           data-vv-as=" "
                                           v-validate="'required'"
                                           :disabled="!tarea.id_empresa"
                                >
                                    <el-option v-for="task in tasks"
                                               :key="task.id"
                                               :label="task.name"
                                               :value="task.id"
                                    />
                                </el-select>

                            </b-col>
                            <b-col cols="1"
                                   class="pl-0"
                            >
                                <el-tooltip
                                    effect="dark"
                                    placement="top"
                                    content="Crear tarea"
                                    popper-class="py-1 px-2"
                                >
                                    <b-button variant="primary"
                                              @click="setModalShowTask(true), setLocationFromAnalysis(tarea.id_ubicacion)"
                                              class="float-right"
                                              size="sm"
                                              :disabled="!tarea.id_empresa || !tarea.id_ubicacion"
                                    >
                                        <i class="fa fa-plus"></i>
                                    </b-button>
                                </el-tooltip>
                            </b-col>
                        </b-row>
                        <div class="text-danger small"
                             v-text="errors.first('tarea.ari_task_id')"
                        />
                    </b-form-group>
                </b-col>

                <b-col md="4">
                    <b-form-group>
                        <label for="wor_position_id">
                            Cargo
                        </label>
                        <b-row>
                            <b-col>
                                <el-select v-model="tarea.wor_position_id"
                                           id="wor_position_id"
                                           name="wor_position_id"
                                           filterable
                                           size="small"
                                           placeholder="Seleccione un Cargo"
                                           class="w-100"
                                           no-data-text="No hay datos que coincidan"
                                           no-match-text="No hay datos que coincidan"
                                           data-vv-as=" "
                                           v-validate="'required'"
                                           :disabled="!tarea.id_empresa"
                                           @change="getWorkers"
                                >
                                    <el-option v-for="position in positions"
                                               :key="position.id"
                                               :label="position.name"
                                               :value="position.id"
                                    />
                                </el-select>
                            </b-col>
                            <b-col cols="1"
                                   class="pl-0"
                            >
                                <el-tooltip
                                    effect="dark"
                                    placement="top"
                                    content="Crear cargo"
                                    popper-class="py-1 px-2"
                                >
                                    <b-button variant="primary"
                                              @click="_setModalShowPosition()"
                                              class="float-right"
                                              size="sm"
                                              :disabled="!tarea.id_empresa"
                                    >
                                        <i class="fa fa-plus"></i>
                                    </b-button>
                                </el-tooltip>
                            </b-col>
                        </b-row>
                        <div class="text-danger small"
                             v-text="errors.first('tarea.wor_position_id')"
                        />
                    </b-form-group>
                </b-col>

                <!-- Proceso -->
                <div class="form-group col-md-4">
                    <label for="proceso">
                        Proceso <span class="text-danger"
                                      v-text="'(*)'"
                    /> :
                    </label>
                    <b-form-input
                        id="proceso"
                        name="proceso"
                        type="text"
                        v-model="tarea.proceso"
                        class="form-input-group text-uppercase"
                        data-vv-as=" "
                        v-validate="'required'"
                    />
                    <div class="text-danger span-error small">
                        {{ errors.first('tarea.proceso') }}
                    </div>
                </div>

                <!-- Nombre del GES -->
                <b-col md="4">
                    <b-form-group>
                        <label for="ari_hygienic_measurement_id">
                            GES
                        </label>
                        <b-row>
                            <b-col>
                                <el-select v-model="tarea.ari_hygienic_measurement_id"
                                           id="ari_hygienic_measurement_id"
                                           name="ari_hygienic_measurement_id"
                                           filterable
                                           size="small"
                                           placeholder="Seleccione un GES"
                                           class="w-100"
                                           no-data-text="No hay datos que coincidan"
                                           no-match-text="No hay datos que coincidan"
                                           data-vv-as=" "
                                           :disabled="!tarea.id_empresa"
                                >
                                    <el-option v-for="hygienic_measurement in hygienic_measurements"
                                               :key="hygienic_measurement.id"
                                               :label="hygienic_measurement.name"
                                               :value="hygienic_measurement.id"
                                    />
                                </el-select>
                            </b-col>
                            <b-col cols="1"
                                   class="pl-0"
                            >
                                <el-tooltip
                                    effect="dark"
                                    placement="top"
                                    content="Crear GES"
                                    popper-class="py-1 px-2"
                                >
                                    <b-button variant="primary"
                                              @click="modalGes = true"
                                              class="float-right"
                                              size="sm"
                                              :disabled="!tarea.id_empresa"
                                    >
                                        <i class="fa fa-plus"></i>
                                    </b-button>
                                </el-tooltip>
                            </b-col>
                        </b-row>
                        <div class="text-danger small"
                             v-text="errors.first('tarea.ari_hygienic_measurement_id')"
                        />
                    </b-form-group>
                </b-col>

                <!-- Numero de trabajadores expuestos -->
                <div class="form-group col-md-4">
                    <label for="numero_trabajadores_expuestos">
                        Numero de trabajadores expuestos <span class="text-danger"
                                                               v-text="'(*)'"
                    /> :
                    </label>
                    <b-form-input
                        id="numero_trabajadores_expuestos"
                        name="numero_trabajadores_expuestos"
                        type="number"
                        step="1"
                        v-model="tarea.numero_trabajadores_expuestos"
                        class="form-input-group text-uppercase"
                        data-vv-as=" "
                        v-validate="'required'"
                    />
                    <div class="text-danger span-error small">
                        {{ errors.first('tarea.numero_trabajadores_expuestos') }}
                    </div>
                </div>
            </div>
        </b-card>

        <!-- TRABAJADORES EXPUESTOS -->
        <b-card class="contenedor">
            <div slot="header"
                 class="text-center font-weight-bold"
            >
                TRABAJADORES EXPUESTOS
            </div>
            <div class="row">
                <div class="col-12">
                    <b-table responsive
                             hover
                             :items="workers"
                             :fields="fields_workers"
                             show-empty
                             small
                             striped
                    >

                    </b-table>
                </div>
            </div>
        </b-card>

        <!-- SECCIÓN DE VALORACIÓN DEL RIESGO -->
        <b-card class="contenedor">
            <div slot="header"
                 class="text-center font-weight-bold"
            >VALORACIÓN DEL RIESGO
            </div>
            <div class="row">
                <!-- Temperatura del proceso -->
                <div class="form-group col-md-4">
                    <label for="id_um_temperatura_proceso">
                        Temperatura del proceso <span class="text-danger"
                                                      v-text="'(*)'"
                    /> :
                    </label>
                    <div class="row">
                        <div class="col-6 px-0 pl-3">
                            <b-form-input
                                id="temperatura_proceso"
                                name="temperatura_proceso"
                                type="number"
                                step="0.001"
                                v-model="tarea.temperatura_proceso"
                                class="form-input-group text-uppercase"
                                data-vv-as=" "
                                v-validate="{ rules: { required: true, decimal: 3 } }"
                            />
                        </div>
                        <el-select
                            id="id_um_temperatura_proceso"
                            name="id_um_temperatura_proceso"
                            v-model="tarea.id_um_temperatura_proceso"
                            placeholder=" "
                            class="col-6 pl-0 text-uppercase"
                            size="small"
                            data-vv-as=" "
                            v-validate="{ rules: { required: !!tarea.temperatura_proceso } }"
                            :disabled="!tarea.temperatura_proceso"
                        >
                            <el-option
                                v-for="item in unidades_de_temperatura"
                                :key="item.id"
                                :label="item.lista"
                                :value="item.id"
                            />
                        </el-select>
                    </div>
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.temperatura_proceso')"
                    />
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.id_um_temperatura_proceso')"
                    />
                </div>

                <!-- Cantidad / día -->
                <div class="form-group col-md-4">
                    <label for="id_cantidad_dia">
                        Cantidad / día <span class="text-danger"
                                             v-text="'(*)'"
                    /> :
                    </label>
                    <div class="row">
                        <div class="col-7 px-0 pl-3">
                            <b-form-input
                                id="cantidad_dia"
                                name="cantidad_dia"
                                type="number"
                                step="0.001"
                                v-model="tarea.cantidad_dia"
                                class="form-input-group text-uppercase"
                                data-vv-as=" "
                                v-validate="'required'"
                            />
                        </div>

                        <el-select
                            id="id_cantidad_dia"
                            name="id_cantidad_dia"
                            v-model="tarea.id_cantidad_dia"
                            placeholder=" "
                            class="col-5 px-0 pr-3 text-uppercase"
                            size="small"
                            data-vv-as=" "
                            :disabled="!tarea.cantidad_dia"
                            v-validate="{ rules: { required: !!tarea.cantidad_dia } }"
                        >
                            <el-option
                                v-for="item in capacidades"
                                :key="item.id"
                                :label="item.lista"
                                :value="item.id"
                            />
                        </el-select>
                    </div>
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.cantidad_dia')"
                    />
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.id_cantidad_dia')"
                    />
                </div>

                <!-- Frecuencia -->
                <div class="form-group col-md-4">
                    <label for="id_cantidad_dia">
                        Frecuencia <span class="text-danger"
                                         v-text="'(*)'"
                    /> :
                    </label>
                    <div class="row">
                        <div class="col-4 pr-0">
                            <b-form-input
                                id="frecuencia"
                                name="frecuencia"
                                type="number"
                                step="0.001"
                                v-model="tarea.frecuencia"
                                class="form-input-group text-uppercase"
                                data-vv-as=" "
                                v-validate="'required|decimal:1'"
                            />
                        </div>
                        <el-select
                            id="id_frecuencia_1"
                            name="id_frecuencia_1"
                            v-model="tarea.id_frecuencia_1"
                            placeholder=" "
                            class="col-4 px-0 text-uppercase"
                            size="small"
                            data-vv-as=" "
                            :disabled="!tarea.frecuencia"
                            v-validate="{ rules: { required: !!tarea.frecuencia, decimal: 3 } }"
                        >
                            <el-option
                                v-for="item in opciones_frecuencia_1"
                                :key="item.id"
                                :label="item.lista"
                                :value="item.id"
                            />
                        </el-select>
                        <el-select
                            id="id_frecuencia_2"
                            name="id_frecuencia_2"
                            v-model="tarea.id_frecuencia_2"
                            placeholder=" "
                            class="col-4 pl-0 text-uppercase"
                            size="small"
                            data-vv-as=" "
                            :disabled="!tarea.id_frecuencia_1"
                            v-validate="{ rules: { required: !!tarea.id_frecuencia_1, decimal: 3 } }"
                        >
                            <el-option
                                v-for="item in opciones_frecuencia_2"
                                :key="item.id"
                                :label="item.lista"
                                :value="item.id"
                            />
                        </el-select>
                    </div>
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.frecuencia')"
                    />
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.id_frecuencia_1')"
                    />
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.id_frecuencia_2')"
                    />
                </div>

                <!--Vía de ingreso -->
                <div class="form-group col-md-4">
                    <label for="id_via_ingreso">
                        Vía de ingreso <span class="text-danger"
                                             v-text="'(*)'"
                    /> :
                    </label>
                    <el-select
                        id="id_via_ingreso"
                        name="id_via_ingreso"
                        class="text-uppercase"
                        v-model="tarea.id_via_ingreso"
                        placeholder=" "
                        size="small"
                        data-vv-as=" "
                        v-validate="'required'"
                    >
                        <el-option
                            v-for="item in vias_ingreso"
                            :key="item.id"
                            :label="item.lista"
                            :value="item.id"
                        />
                    </el-select>
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.id_via_ingreso')"
                    />
                </div>

                <!-- Superficie expuesta (dérmico) -->
                <div class="form-group col-md-4">
                    <label for="id_superficie_expuesta_dermico">
                        Superficie expuesta (dérmico)
                        <span v-if="viaIngreso === 'DÉRMICA'"
                              class="text-danger"
                              v-text="'(*)'"
                        /> :
                    </label>
                    <el-select
                        id="id_superficie_expuesta_dermico"
                        name="id_superficie_expuesta_dermico"
                        class="text-uppercase"
                        v-model="tarea.id_superficie_expuesta_dermico"
                        :disabled="viaIngreso !== 'DÉRMICA'"
                        placeholder=" "
                        size="small"
                        data-vv-as=" "
                        v-validate="{ rules: { required: tarea.id_via_ingreso === 2 } }"
                    >
                        <el-option
                            v-for="item in opciones_superficies_expuestas"
                            :key="item.id"
                            :label="item.lista"
                            :value="item.id"
                        />
                    </el-select>
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.id_superficie_expuesta_dermico')"
                    />
                </div>

                <!-- Clase de pulverulencia (SOLIDO) -->
                <div class="form-group col-md-4">
                    <label for="id_clase_pulverulencia">
                        Clase de pulverulencia (SOLIDO)
                        <span v-if="estado === 'SOLIDO'"
                              class="text-danger"
                              v-text="'(*)'"
                        /> :
                    </label>
                    <el-select
                        id="id_clase_pulverulencia"
                        name="id_clase_pulverulencia"
                        :disabled="estado !== 'SOLIDO'"
                        v-model="tarea.id_clase_pulverulencia"
                        placeholder=" "
                        size="small"
                        data-vv-as=" "
                        v-validate="{ rules: { required: estado === 'SOLIDO' } }"
                    >
                        <el-option
                            v-for="item in clases_de_pulverulencia"
                            :key="item.id"
                            :label="item.lista"
                            :value="item.id"
                        />
                    </el-select>
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.id_clase_pulverulencia')"
                    />
                </div>

                <!-- Clase de procedimiento -->
                <div class="form-group col-md-4">
                    <label for="id_clase_procedimiento">
                        Clase de procedimiento <span class="text-danger"
                                                     v-text="'(*)'"
                    /> :
                    </label>
                    <el-select
                        id="id_clase_procedimiento"
                        name="id_clase_procedimiento"
                        v-model="tarea.id_clase_procedimiento"
                        placeholder=" "
                        size="small"
                        data-vv-as=" "
                        v-validate="'required'"
                    >
                        <el-option
                            v-for="item in clases_de_procedimiento"
                            :key="item.id"
                            :label="item.lista"
                            :value="item.id"
                        />
                    </el-select>
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.id_clase_procedimiento')"
                    />
                </div>

                <!-- Total horas semanales laborales -->
                <div class="form-group col-md-4">
                    <label for="total_horas_semanales_laborales">
                        Total horas semanales laborales <span class="text-danger"
                                                              v-text="'(*)'"
                    /> :
                    </label>
                    <b-form-input
                        id="total_horas_semanales_laborales"
                        name="total_horas_semanales_laborales"
                        type="number"
                        step="1"
                        v-model="tarea.total_horas_semanales_laborales"
                        class="form-input-group"
                        data-vv-as=" "
                        v-validate="'required'"
                    />
                    <div class="text-danger span-error small">
                        {{ errors.first('tarea.total_horas_semanales_laborales') }}
                    </div>
                </div>

                <!-- Toral horas diarias laborales -->
                <div class="form-group col-md-4">
                    <label for="total_horas_diarias_laborales">
                        Toral horas diarias laborales <span class="text-danger"
                                                            v-text="'(*)'"
                    /> :
                    </label>
                    <b-form-input
                        id="total_horas_diarias_laborales"
                        name="total_horas_diarias_laborales"
                        type="number"
                        step="1"
                        v-model="tarea.total_horas_diarias_laborales"
                        class="form-input-group"
                        data-vv-as=" "
                        v-validate="'required'"
                    />
                    <div class="text-danger span-error small">
                        {{ errors.first('tarea.total_horas_diarias_laborales') }}
                    </div>
                </div>

                <!-- TLV -->
                <div class="form-group col-md-4">
                    <label for="id_unidad_medida_tlv">
                        TLV <span class="text-danger"
                                  v-text="'(*)'"
                    /> :
                    </label>
                    <div class="row">
                        <div class="col-8 px-0 pl-3">
                            <b-form-input
                                id="tlv"
                                name="tlv"
                                type="text"
                                v-model="tarea.tlv"
                                class="form-input-group"
                                data-vv-as=" "
                                :disabled="!tarea.id_componente"
                                v-validate="{ rules: { required: true, decimal: 10 } }"
                            />
                        </div>
                        <el-select
                            id="id_unidad_medida_tlv"
                            name="id_unidad_medida_tlv"
                            v-model="tarea.id_unidad_medida_tlv"
                            placeholder=" "
                            class="col-4 px-0 pr-3"
                            size="small"
                            data-vv-as=" "
                            v-validate="{ rules: { required: !!tarea.tlv } }"
                            :disabled="!tarea.tlv || !tarea.id_componente"
                        >
                            <el-option
                                v-for="item in unidades_de_medida_tlv"
                                :key="item.id"
                                :label="item.lista"
                                :value="item.id"
                            />
                        </el-select>
                    </div>
                    <div class="text-danger span-error small"
                         v-text="errors.first('tarea.tlv')"
                    />
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.id_unidad_medida_tlv')"
                    />
                </div>

                <!-- PRESIÓN DE VAPOR CORREGIDA -->
                <div class="form-group col-md-4">
                    <label for="presion_vapor_corregida">
                        Presión de vapor corregida (Kpa) <span class="text-danger"
                                                               v-text="'(*)'"
                    /> :
                    </label>
                    <b-form-input
                        id="presion_vapor_corregida"
                        name="presion_vapor_corregida"
                        type="number"
                        step="0.001"
                        v-model="tarea.presion_vapor_corregida"
                        class="form-input-group"
                        data-vv-as=" "
                        v-validate="'required|decimal:3'"
                    />
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.presion_vapor_corregida')"
                    />
                </div>
            </div>

            <div class="row">
                <!-- CLASE DE PROTECCIÓN COLECTIVA -->
                <div class="form-group col-12">
                    <label for="id_proteccion_colectiva"
                           class="w-100"
                    >
                        Clase de protección colectiva
                    </label>
                    <el-radio-group
                        v-model="tarea.id_proteccion_colectiva"
                        v-validate="'required'"
                        size="mini"
                    >
                        <el-radio
                            v-for="opcion in opciones_proteccion_colectiva"
                            :label="opcion"
                            :key="opcion"
                            class="checkbox-imagen"
                        >
                            <img
                                :src="'img/ari/tareas/proteccion_colectiva/opcion_' + opcion + '.PNG'"
                                class="imagen-checkbox"
                                height="140"
                            />
                        </el-radio>
                    </el-radio-group>
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.id_proteccion_colectiva')"
                    />
                </div>
            </div>

            <div class="row">
                <!-- ¿Producto en suspensión liquida? "Spray" -->
                <div class="form-group col-lg-3 col-md-6">
                    <label for="suspension_liquida"
                           class="w-100"
                    >
                        ¿Producto en suspensión liquida? "Spray"
                    </label>
                    <b-form-radio-group
                        v-model="tarea.suspension_liquida"
                        :button-variant="
              tarea.suspension_liquida ? 'outline-primary' : 'outline-secondary'
            "
                        :options="opciones_si_no"
                        size="md"
                        buttons
                    />
                </div>

                <!-- ¿TLV tiene nota IFV? -->
                <div class="form-group col-lg-3 col-md-6">
                    <label for="nota_ifv"
                           class="w-100"
                    > ¿TLV tiene nota IFV? </label>
                    <b-form-radio-group
                        v-model="tarea.nota_ifv"
                        :button-variant="tarea.nota_ifv ? 'outline-primary' : 'outline-secondary'"
                        :options="opciones_si_no"
                        size="md"
                        buttons
                    />
                </div>

                <!-- ¿Tiene azeotropo? -->
                <div class="form-group col-lg-3 col-md-6">
                    <label for="azeotropo"
                           class="w-100"
                    > ¿Tiene azeotropo? </label>
                    <b-form-radio-group
                        v-model="tarea.azeotropo"
                        :button-variant="tarea.azeotropo ? 'outline-primary' : 'outline-secondary'"
                        :options="opciones_si_no"
                        size="md"
                        buttons
                    />
                </div>

                <div class="form-group col-lg-3 col-md-6">
                    <label for="id_um_temperatura_azeotropo">
                        Temperatura del azeotropo
                        <span class="text-danger"
                              v-if="!!tarea.azeotropo"
                              v-text="'(*)'"
                        /> :
                    </label>
                    <div class="row">
                        <div class="col-6 px-0 pl-3">
                            <b-form-input
                                id="temperatura_azeotropo"
                                name="temperatura_azeotropo"
                                type="number"
                                step="0.001"
                                :disabled="!tarea.azeotropo"
                                v-model="tarea.temperatura_azeotropo"
                                class="form-input-group"
                                data-vv-as=" "
                                v-validate="{ rules: { required: !!tarea.azeotropo, decimal: 3 } }"
                            />
                        </div>

                        <el-select
                            id="id_um_temperatura_azeotropo"
                            name="id_um_temperatura_azeotropo"
                            v-model="tarea.id_um_temperatura_azeotropo"
                            :disabled="!tarea.azeotropo || !tarea.temperatura_azeotropo"
                            placeholder=" "
                            class="col-6 px-0 pr-3"
                            size="small"
                            data-vv-as=" "
                            v-validate="{ rules: { required: !!tarea.azeotropo } }"
                        >
                            <el-option
                                v-for="item in unidades_de_temperatura"
                                :key="item.id"
                                :label="item.lista"
                                :value="item.id"
                            />
                        </el-select>
                    </div>
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.temperatura_azeotropo')"
                    />
                    <div
                        class="text-danger span-error small"
                        v-text="errors.first('tarea.id_um_temperatura_azeotropo')"
                    />
                </div>

                <!-- ¿Tiene una operación de pulverización? -->
                <div class="form-group col-lg-3 col-md-6">
                    <label for="operacion_pulverizacion"
                           class="w-100"
                    >
                        ¿Tiene una operación de pulverización?
                    </label>
                    <b-form-radio-group
                        v-model="tarea.operacion_pulverizacion"
                        :button-variant="
              tarea.operacion_pulverizacion ? 'outline-primary' : 'outline-secondary'
            "
                        :options="opciones_si_no"
                        size="md"
                        buttons
                    />
                </div>

                <!-- ¿Tiene cambio de temperatura que afecta el estado físico del agente químico? -->
                <div class="form-group col-lg-3 col-md-6">
                    <label for="cambio_temperatura"
                           class="w-100"
                    >
                        ¿Tiene cambio de temperatura que afecta el estado físico del agente químico?
                    </label>
                    <b-form-radio-group
                        v-model="tarea.cambio_temperatura"
                        :button-variant="
              tarea.cambio_temperatura ? 'outline-primary' : 'outline-secondary'
            "
                        :options="opciones_si_no"
                        size="md"
                        buttons
                    />
                </div>

                <!-- ¿Es un plaguicida? -->
                <div class="form-group col-lg-3 col-md-6">
                    <label for="plaguicida"
                           class="w-100"
                    > ¿Es un plaguicida? </label>
                    <b-form-radio-group
                        v-model="tarea.plaguicida"
                        :button-variant="tarea.plaguicida ? 'outline-primary' : 'outline-secondary'"
                        :options="opciones_si_no"
                        size="md"
                        buttons
                    />
                </div>
            </div>

            <!-- BOTONES -->
            <hr/>
            <div class="row">
                <div v-if="errors.items.length"
                     class="col-12 text-danger text-center small my-2"
                >
                    <i class="fa fa-warning"/>
                    Existen errores de validación de datos
                </div>
                <div class="col-12 text-center mt-2">
                    <b-button
                        size="sm"
                        class="mx-2 float-left"
                        variant="secondary"
                        to="/analisis-de-riesgos/analisis"
                    >
                        <i class="fa fa-backward"/> Volver
                    </b-button>
                    <button class="btn btn-sm btn-primary mx-2">
                        <i class="fa fa-save"/> {{ accion }}
                    </button>
                    <button
                        v-if="accion === 'Actualizar'"
                        class="btn btn-sm btn-primary mx-2"
                        @click.stop="validarFormulario(true)"
                    >
                        <i class="fa fa-plus"/> Guardar como nuevo
                    </button>
                </div>
            </div>
        </b-card>

        <modal/>

        <modal-propiedades
            :validationMolecularWeight="validationMolecularWeight"
            @flag-save-properties="flagSaveProperties = $event"
            @update:validationMolecularWeight="val => {
                if ((tarea.id_unidad_medida_tlv == 223 || tarea.id_unidad_medida_tlv == 928) && val) {
                    validationMolecularWeight = val;
                }
            }"
        />
        <ModalCreateProduct
            v-if="tarea.id_empresa && accion !== 'Actualizar'"
            :module="'ari'"
        />

        <modal_attachments v-if="modal_attachments.view"/>
        <modal_task/>
        <modal_position/>

        <b-modal v-model="modalGes" size="lg" hide-footer no-close-on-backdrop no-close-on-esc>
            <template #modal-title>
                <div>Crear GES</div>
            </template>
            <hygienic_measurement v-if="tarea.id_empresa" :companyId="tarea.id_empresa" @close="handleClose" :isComponent="true" />
        </b-modal>

        <transition name="fade" v-if="accion === 'Actualizar' && !modal.ver">
            <b-alert
                variant="alert"
                class="info-bar-custom text-center mb-1 p-2"
                style="position: fixed; bottom: 24px; left: 50%; transform: translateX(-50%); z-index: 9999; width: 100%; max-width: 500px;"
                show
            >
                <template v-if="!formChanged">
                    El análisis de riesgos ya fue evaluado con estas condiciones. Puedes ver la valoración a continuación
                    <b-button size="sm" variant="primary" class="mb-0" @click="establecerModalVer(true)">
                        <i class="fa fa-list"></i> Ver
                    </b-button>
                </template>
                <template v-else>
                    Debe actualizar para poder ver los resultados nuevos.
                </template>
            </b-alert>
        </transition>

    </form>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import TreeSelect from '@riophae/vue-treeselect';
import Modal from './modal';
import ModalPropiedades from './modal_propiedades';
import {getAcls} from '../../../plugins/acl';
import modalProductoComponente from './../../productos/ModalProductoComponente.vue';
import casTlv from './../../productos/cas/nuevoCas/Crear.vue';
import ModalCreateProduct from '../../accidents_high/ModalCreateProduct.vue';
import modal_attachments from './modal_attachments';
import modal_task from './modal_task.vue';
import modal_position from './modal_position.vue';
import hygienic_measurement from '../hygienic_measurements/hygienic_measurement.vue';

export default {
    name: 'formulario',
    components: {
        TreeSelect,
        Modal,
        ModalPropiedades,
        modalProductoComponente,
        casTlv,
        modal_task,
        modal_position,
        ModalCreateProduct,
        modal_attachments,
        hygienic_measurement
    },
    data() {
        return {
            mostrar_select: true,
            columnas: [
                {
                    key: 'select',
                    label: ' ',
                    sortable: false,
                },
                {
                    key: 'nameComponent',
                    label: 'Componente',
                    sortable: false,
                },
                {
                    key: 'cas_number',
                    label: 'No. CAS',
                    sortable: false,
                },
                {
                    key: 'acgihtwa',
                    label: 'ACGIH TWA',
                    sortable: false,
                },
                {
                    key: 'lista',
                    label: 'Unidad',
                    sortable: false,
                },
                {
                    key: 'acgihstel',
                    label: 'ACGIH STEL',
                    sortable: false,
                },
            ],
            fields_workers: [
                {
                    key: 'identification',
                    label: 'Identificación',
                },
                {
                    key: 'surnames',
                    label: 'Apellidos',
                },
                {
                    key: 'names',
                    label: 'Nombres',
                }
            ],
            modal_tlv: false,
            modalGes: false,
            fabricante: null,
            validationMolecularWeight: false,
            flagSaveProperties: false,
            formChanged: false,
            originalFormData: null,
            isInitializing: false,
        };
    },
    watch: {
        tarea: {
            handler(newVal) {
                if (!this.isInitializing) {
                    this.checkFormChanges();
                }
            },
            deep: true
        },
        async 'tarea.id_unidad_medida_tlv'(newVal) {
            if (newVal == 223 || newVal == 928) {
                if(this.tarea.id_producto){
                    await this.obtenerPropiedades(this.tarea.id_producto);
                    if(this.propiedades.peso_molecular == null || this.propiedades.peso_molecular == 0 || this.propiedades.peso_molecular == '') {
                        this._obtenerPropiedades();
                        this.validationMolecularWeight = true;
                    }
                }
            }else {
                this.validationMolecularWeight = false;
            }
        }
    },
    async mounted() {
        let acls = getAcls();

        await this.inicializarComponente();

        this.mostrar_select = !!acls.roles.filter((r) =>
            ['superadmin', 'admin', 'admin-tecnico'].includes(r)
        ).length;

        if (!this.mostrar_select) {
            const id_empresa = await this.obtenerIdEmpresaUsuario();

            this.establecerIdEmpresaTarea(id_empresa);

            await this.obtenerDatosPorEmpresa(id_empresa);
            let company = {
                id: id_empresa,
                nombre: (function () {
                    const empresa = this.empresas.find(e => e.id === id_empresa);
                    return empresa ? empresa.nombre : null;
                    }).call(this)
            };
            this.setCompany(company);
            this.setLocations(this.ubicaciones);
        }

        await this.obtenerUnidadesDeTemperatura();

        await this.getIdioma();
        await this.getTipo();
        await this.getEstadoFds();
    },
    computed: {
        ...mapState('analysis', [
            'tareas',
            'tarea',
            'accion',
            'empresas',
            'fabricantes',
            'productos',
            'ubicaciones',
            'componentes',
            'tipos_de_empaque',
            'unidades_de_presion',
            'unidades_de_viscosidad',
            'opciones_frecuencia_1',
            'opciones_frecuencia_2',
            'cargos',
            'ges',
            'opciones_si_no',
            'opciones_proteccion_colectiva',
            'categorias',
            'categorias_sga',
            'vias_ingreso',
            'cargando_datos_select',
            'unidades_de_temperatura',
            'unidades_de_presion',
            'unidades_de_viscosidad',
            'capacidades',
            'opciones_superficies_expuestas',
            'clases_de_procedimiento',
            'clases_de_pulverulencia',
            'unidades_de_medida_tlv',
            'modal_propiedades',
            'modal_attachments',
            'tasks',
            'positions',
            'hygienic_measurements',
            'workers',
            'propiedades',
            'modal',
        ]),
        ...mapState('productos', ['estados']),
        estado() {
            const producto = this.productos.find((p) => p.id === this.tarea.id_producto);

            if (!producto || !producto.lista_estado) {
                return '';
            }

            if (this.accion === 'Crear') {
                this.tarea.estado_producto = producto.lista_estado.id;
            }

            // Normalize the text: remove accents, tildes, and other special characters
            return this.normalizeText(producto.lista_estado.lista).toUpperCase();
        },
        viaIngreso() {
            const via_ingreso = this.vias_ingreso.find(
                (vi) => vi.id === this.tarea.id_via_ingreso
            );

            if (!via_ingreso || !via_ingreso.codigo) {
                return '';
            }

            return via_ingreso.lista.toUpperCase();
        },
    },
    methods: {
        ...mapMutations('nuevocas', ['establecerModalProductoComponente']),
        ...mapMutations('productos', ['cargarEstados']),
        ...mapMutations('analysis', [
            'establecerIdUbicacion',
            'establecerIdCargo',
            'establecerIdGes',
            'establecerAccion',
            'establecerIdComponente',
            'establecerIdCategoria',
            'establecerIdProducto',
            'limpiarTarea',
            'establecerClaseDePulverulencia',
            'establecerModalVer',
            'establecerModalPropiedadesVer',
            'establecerIdEmpresaTarea',
            'setDefaultPropiedades',
            'establecerUbicaciones',
            'setProductSelected',
        ]),
        ...mapActions('analysis', [
            'crearTarea',
            'actualizarTarea',
            'obtenerCargos',
            'obtenerGes',
            'obtenerEmpresas',
            'obtenerFabricantes',
            'obtenerUbicacionesGenerales',
            'obtenerTarea',
            'obtenerProductos',
            'obtenerComponentes',
            'obtenerCategorias',
            'establecerIdComponente',
            'obtenerUnidadesDeTemperatura',
            'getControls',
            'obtenerCapacidades',
            'obtenerOpcionesDeFrecuencia1',
            'obtenerOpcionesDeFrecuencia2',
            'obtenerViasDeIngreso',
            'obtenerSuperficiesExpuestas',
            'obtenerClasesDeProcedimiento',
            'obtenerClasesDePulverulencia',
            'obtenerUnidadesDeMedidaTlv',
            'obtenerPropiedades',
            'fetchTasks',
            'fetchPositions',
            'fetchHygienicMeasurements',
            'getWorkers',
            'getPositions'
        ]),
        ...mapActions('findings', ['getResponsibles']),
        ...mapActions('dashboard', ['validarPermiso', 'obtenerIdEmpresaUsuario']),
        ...mapMutations('dashboard', ['load']),
        ...mapActions('productos', ['getEstados', 'obtainSafetyDataSheets']),
        ...mapMutations('accidents_high', [
            'setModalCreateNewProduct',
            'setLocations',
            'setCompany',
        ]),
        ...mapMutations('tasks',
            {
                setModalShowTask: 'setModalShow',
                setLocationFromAnalysis: 'setLocationFromAnalysis'
            }
        ),
        ...mapMutations('positions',
            {
                setModalShowPosition: 'setModalShow',
                resetPosition: 'resetPosition'
            }
        ),
        ...mapMutations('hygienic_measurements',
            {setModalShowHygienicMeasurements: 'setModalShow'}
        ),
        ...mapActions('adjuntos', ['getIdioma', 'getTipo', 'getEstadoFds']),
        normalizeText(text) {
            if (!text) return '';

            // Remove accents, tildes, and normalize string
            return text
                .normalize('NFD') // Normalize to decomposed form
                .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
                .replace(/[^a-zA-Z0-9\s]/g, ''); // Remove special characters except alphanumerics and spaces
        },
        _setModalShowPosition(){
            this.resetPosition();
            this.setModalShowPosition(true)
        },
        async handleClose() {
            this.modalGes = false;
            await this.fetchHygienicMeasurements();
        },
        async _setModalCreateNewProductView() {
            await this.getEstados();
            this.setModalCreateNewProduct(true);
        },
        async inicializarComponente() {

            await this.getControls();
            await this.obtenerUnidadesDeTemperatura();
            await this.obtenerCapacidades();
            await this.obtenerOpcionesDeFrecuencia1();
            await this.obtenerOpcionesDeFrecuencia2();
            await this.obtenerViasDeIngreso();
            await this.obtenerSuperficiesExpuestas();
            await this.obtenerClasesDeProcedimiento();
            await this.obtenerClasesDePulverulencia();
            await this.obtenerUnidadesDeMedidaTlv();

            this.limpiarTarea();

            this.establecerAccion('Crear');

            await this.getUpdate();
        },
        async _obtenerPropiedades() {
            this.setDefaultPropiedades();
            await this.obtenerUnidadesDeTemperatura();
            await this.obtenerPropiedades(this.tarea.id_producto);

            this.establecerModalPropiedadesVer(true);
        },
        async validarFormulario(crear_como_nuevo = null) {
            if(this.validationMolecularWeight){
                if((this.propiedades.peso_molecular == null || Number(this.propiedades.peso_molecular) == 0 || this.propiedades.peso_molecular !== '') && !this.flagSaveProperties) {
                    this._obtenerPropiedades();
                    return;
                }
            }

            if (crear_como_nuevo != null) {
                this.establecerAccion('Crear');
            }

            await this.$validator.validateAll('tarea').then(async (result) => {
                if (result) {
                    if (this.accion === 'Crear') {
                        await this.crearTarea().then(async (tarea) => {
                            await this.$router.push(
                                `/analisis-de-riesgos/analisis/formulario/${tarea.id}/${tarea.id_empresa}`
                            );
                        });
                        this.establecerModalVer(true);
                    } else {
                        await this.actualizarTarea();
                        this.saveOriginalFormData();
                    }

                    await this.getUpdate();
                }
            });
        },
        saveOriginalFormData() {
            this.isInitializing = true;
            this.originalFormData = JSON.parse(JSON.stringify(this.tarea));
            this.formChanged = false;
            this.$nextTick(() => {
                this.isInitializing = false;
            });
        },
        checkFormChanges() {
            if (!this.originalFormData) {
                this.formChanged = false;
                return;
            }

            this.formChanged = !this.deepEqual(this.tarea, this.originalFormData);
        },
        deepEqual(obj1, obj2) {
            if (obj1 === obj2) {
                return true;
            }

            if (obj1 == null || obj2 == null) {
                return obj1 === obj2;
            }

            if (typeof obj1 !== typeof obj2) {
                if ((typeof obj1 === 'number' && typeof obj2 === 'string') ||
                    (typeof obj1 === 'string' && typeof obj2 === 'number')) {
                    return String(obj1) === String(obj2);
                }

                if ((obj1 === null || obj1 === undefined || obj1 === '') &&
                    (obj2 === null || obj2 === undefined || obj2 === '')) {
                    return true;
                }
                return false;
            }

            if (typeof obj1 !== 'object') {
                return obj1 === obj2;
            }

            if (Array.isArray(obj1) !== Array.isArray(obj2)) {
                return false;
            }

            if (Array.isArray(obj1)) {
                if (obj1.length !== obj2.length) {
                    return false;
                }
                for (let i = 0; i < obj1.length; i++) {
                    if (!this.deepEqual(obj1[i], obj2[i])) {
                        return false;
                    }
                }
                return true;
            }

            const keys1 = Object.keys(obj1);
            const keys2 = Object.keys(obj2);

            if (keys1.length !== keys2.length) {
                return false;
            }

            for (let key of keys1) {
                if (!keys2.includes(key)) {
                    return false;
                }
                if (!this.deepEqual(obj1[key], obj2[key])) {
                    return false;
                }
            }

            return true;
        },
        async obtenerDatosPorEmpresa(id_empresa) {
            if (!id_empresa) {
                this.establecerIdUbicacion(null);
                this.establecerIdCargo(null);
                this.establecerIdGes(null);
            }

            const params = {company_id:id_empresa};
            if(this.tarea.location_ids)params.location_ids = this.tarea.location_ids;
            await this.obtenerUbicacionesGenerales(params);

            let company = { id: id_empresa, nombre: ''};

            if (this.empresas.length){
              let company = {
                  id: id_empresa,
                  nombre: this.empresas.find((e) => e.id === id_empresa).nombre,
              };
            }

             this.setCompany(company);
             this.setLocations(this.ubicaciones);
            await this.fetchTasks();
            await this.getPositions();
            await this.fetchHygienicMeasurements();
        },
        async obtenerDatosPorProducto(id_producto) {
            await this.getEstados();
            if (!id_producto) {
                this.establecerIdComponente(null);
                this.establecerIdCategoria(null);
            }

            this.establecerClaseDePulverulencia();

            await this.obtenerComponentes(id_producto);
            await this.obtenerCategorias(id_producto);

            if (this.productos.length && this.productos.length > 0 && id_producto) {
                const producto = this.productos.find((p) => p.id === id_producto);
                if (producto && producto.fabricante) {
                    this.fabricante = producto.fabricante.nombre ?
                        producto.fabricante.nombre : 'NO REGISTRA';
                }
            }
        },
        normalizer(node) {
            return {
                children: node.children && node.children.length ? node.children : 0,
            };
        },
        async getUpdate(){
            if (this.$route.params.id) {
                this.establecerAccion('Actualizar');

                let parametros = {
                    id: this.$route.params.id,
                    id_empresa: this.$route.params.id_empresa,
                };

                await this.obtenerTarea(parametros);
                this.establecerModalVer(true);

                await this.obtenerDatosPorEmpresa(this.tarea.id_empresa);
                await this.obtenerDatosPorProducto(this.tarea.id_producto);

                this.establecerIdUbicacion(this.tarea.id_ubicacion);
                await this.getWorkers();

                this.saveOriginalFormData();
            } else {
                this.$nextTick(() => {
                    this.saveOriginalFormData();
                });
            }
        }
    },
};
</script>

<style
    src="../../../../node_modules/@riophae/vue-treeselect/dist/vue-treeselect.min.css"
></style>

<style scoped>
.vue-treeselect__no-children-tip {
    display: none;
}

.imagen-checkbox {
    box-shadow: 0 0 3px #b8b8b8;
}

.is-checked .imagen-checkbox {
    box-shadow: 0px 1px 10px #097b83;
    border: 1px solid #097b83;
}

.checkbox-imagen .el-radio__input {
    display: none;
}

.info-bar-custom {
  background: #f5e8ff;
  border: 1px solid #097B83;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .info-bar-custom {
    max-width: 90%;
    padding: 12px;
  }
}

</style>
